'use client';

import React from 'react';

const customer = [
  { k: '10–15 h', l: 'Saved per PM / week', ref: 'AppFolio: 10h' },
  { k: '+50–75 %', l: 'Lead-to-lease lift', ref: 'AppFolio: 73%' },
  { k: '50–70 %', l: 'AP time cut', ref: 'Yardi: 60%' },
  { k: '70–80 %', l: 'Close time cut', ref: 'Yardi: 20h → 5h' },
  { k: '30–50 %', l: 'Faster resolution', ref: 'AppFolio / Yardi' },
  { k: '95 %+', l: 'Lease abstraction saved', ref: 'JLL benchmark' },
  { k: '5–15 %', l: 'Churn reduction', ref: 'McKinsey' },
  { k: '10–20 %', l: 'Energy savings', ref: 'CBRE · Prologis' },
  { k: '3–8 %', l: 'NOI improvement', ref: 'Aggregate impact' },
];

const internal = [
  { k: '>90 %', l: 'Agent task completion' },
  { k: '<10 %', l: 'Human override rate (mature)' },
  { k: '<1 %', l: 'LLM hallucination rate' },
  { k: '>95 %', l: 'Extraction accuracy' },
  { k: '<2 s', l: 'Chat latency (p95)' },
  { k: '<2 %', l: 'Eval regression rate' },
];

export default function AIKpis() {
  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-6xl mx-auto">
        <div className="reveal-blur mb-12">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-[rgba(124,58,237,0.25)] mb-5">
            <span className="text-[10px] font-mono text-[#A78BFA] tracking-widest uppercase">
              KPIs & Success Metrics
            </span>
          </div>
          <h2
            className="font-manrope font-extrabold tracking-tighter text-[#EEEEF0]"
            style={{ fontSize: 'clamp(1.75rem, 4vw, 3rem)' }}
          >
            The numbers we commit to.
          </h2>
          <p className="mt-4 text-[#9999A8] max-w-2xl leading-relaxed">
            Every agent ships with an eval. Every customer sees a dashboard. No black-box claims.
          </p>
        </div>

        {/* Customer-facing metrics */}
        <div className="mb-10">
          <div className="text-[10px] font-mono text-[#A78BFA] tracking-widest uppercase mb-5">
            Customer-facing · What sales quotes
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3 stagger-children">
            {customer.map((m) => (
              <div key={m.l} className="reveal-blur bento-card p-5 relative overflow-hidden">
                <div
                  className="font-manrope font-extrabold text-3xl md:text-4xl tracking-tighter"
                  style={{
                    background: 'linear-gradient(135deg, #A78BFA, #7C3AED)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                  }}
                >
                  {m.k}
                </div>
                <div className="text-xs font-manrope text-[#EEEEF0] mt-1 leading-snug">{m.l}</div>
                <div className="text-[10px] font-mono text-[#5A5A6E] mt-2">ref · {m.ref}</div>
                <div className="scan-line" />
              </div>
            ))}
          </div>
        </div>

        {/* Internal AI metrics */}
        <div>
          <div className="text-[10px] font-mono text-[#22C55E] tracking-widest uppercase mb-5">
            Internal · What engineering watches
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 stagger-children">
            {internal.map((m) => (
              <div key={m.l} className="reveal-blur bento-card p-4 text-center">
                <div
                  className="font-manrope font-extrabold text-xl md:text-2xl tracking-tight"
                  style={{ color: '#22C55E' }}
                >
                  {m.k}
                </div>
                <div className="text-[11px] font-mono text-[#9999A8] mt-1 leading-snug">{m.l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
